import { getRequestId } from 'core/services/bff';
import { CLEAR_SALE_APPKEY } from 'ui/scripts/Clearsale/ClearsaleScript';

export function checkUrl(url) {
  const request = new XMLHttpRequest();

  request.open('GET', url, true);
  request.send(null);

  request.onerror = () => {
    request.open(
      'GET',
      `https://web.fpcs-monitor.com.br/p/fp.png?sid=${getRequestId()}&app=${CLEAR_SALE_APPKEY}&bl=1`,
      false,
    );

    request.send(null);
  };
}
